import React from 'react';
import PropTypes from 'prop-types';

// Import context
import { ShakaPlayerProvider } from 'components/context/player/player_vod';

// Import utilities
import { useFullScreen, Portal, ShakaPlayerFocus, useSystemSupport } from 'components/utilities';

// Import components
import { Loader, PlayerError, SupportError } from 'components/elements';
import { ShakaPlayerContent } from './player_content/shaka_player';
import { Root, EmbedWrapper } from './styles';

export default function PlayerWrapper({ isReady, playerType, isError, errorMessage, toggle, isPreview = false, isLoading, isHls }) {
	const { elementRef, isEnabled } = useFullScreen(toggle, isPreview);

	const { showSupportMessage, supportError, setSupportAccept } = useSystemSupport();

	const isPortal = !isEnabled && isPreview;

	return (
		<Portal isPortal={isPortal}>
			<ShakaPlayerFocus intervalTime={250} isReady={isReady}>
				{({ isFocus, resetFocus }) => (
					<Root isPortal={isPortal}>
						<EmbedWrapper ref={elementRef} id={playerType}>
							{isLoading && <Loader background={false} position="absolute" zIndex={1} />}
							{!isLoading && !isError && (
								<ShakaPlayerProvider
									closePreview={toggle}
									isPreview={isPreview}
									type={playerType}
									isFocus={isFocus}
									resetFocus={resetFocus}
									isHls={isHls}
								>
									<ShakaPlayerContent type={playerType} isFocus={isFocus} />
								</ShakaPlayerProvider>
							)}
							{isError && <PlayerError error={{ message: errorMessage }} />}
							{showSupportMessage && <SupportError error={supportError} setSupportAccept={setSupportAccept} playerType={playerType} />}
						</EmbedWrapper>
					</Root>
				)}
			</ShakaPlayerFocus>
		</Portal>
	);
}

PlayerWrapper.propTypes = {
	isReady: PropTypes.bool.isRequired,
	playerType: PropTypes.string.isRequired,
	isError: PropTypes.bool.isRequired,
	errorMessage: PropTypes.string,
	toggle: PropTypes.func,
	isPreview: PropTypes.bool,
	isLoading: PropTypes.bool.isRequired,
	isHls: PropTypes.bool.isRequired
};
